import { FC } from 'react';
import { Paper, Title, Text, Skeleton } from '@mantine/core';

import classes from './ListCard.module.scss';

interface ListCardProps {
  title: string;
  list: string[];
  isLoading: boolean;
}

const ListCard: FC<ListCardProps> = ({ title, list, isLoading }) => {
  const cardList = isLoading ? Array(3).fill(null) : list;

  return (
    <Paper withBorder p="lg" radius="md" bg="var(--bg-color)">
      <Title size="sm" mb="md" mt="xs">
        {title}
      </Title>

      <ul className={classes.list}>
        {cardList.map((item, index) => (
          <li key={index}>
            {isLoading ? (
              <Skeleton w="100%" h={20} styles={{ root: { top: '0.25rem' } }} />
            ) : (
              <Text fz="sm" opacity={0.8}>
                {item}
              </Text>
            )}
          </li>
        ))}
      </ul>
    </Paper>
  );
};

export default ListCard;
